import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Cipbitheader from './Cipbitheader'
import Footer from "../Layout/Footer"
import HttpClient from '../utils/HttpClient';
import toast from 'react-hot-toast';
export default function SingleLayout() {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const location = useLocation();
  const navbg = true;
  const NavbarBgRoutes = ['/eventsCalender', '/editexistingrevenue', '/transaction-details', '/postnewincome', '/newexpense', '/viewexpensedetails', '/edit-expense-details', '/budget-tracker', '/create-invoice', '/view-invoice', '/project-budget-setup', '/project-performance', '/bookkeper', '/bookKeperDocs', '/dashboard-manager', '/raise-capital', '/view-investor-document', '/view-capital-option', '/document-manager', '/achievements', '/configuration', '/users', '/userform', '/buildReport', '/view_reports', '/resource', '/link-manage-account', '/link-manage-investment', '/investment-options'];
  const FreeLicenseRouter = ['/postnewincome', '/editexistingrevenue', '/newexpense', '/viewexpensedetails', '/edit-expense-details', '/budget-tracker', '/create-invoice', '/view-invoice', '/project-budget-setup', '/project-performance', '/bookkeper', '/bookKeperDocs', '/dashboard-manager', '/raise-capital', '/view-investor-document', '/view-capital-option', '/document-manager', '/achievements', '/configuration', '/users', '/userform', '/buildReport', '/view_reports', '/resource', '/link-manage-account', '/link-manage-investment', '/investment-options'];

  const checkUserSubscription = async () => {
    try {
      const res = await HttpClient.requestData('isSubccribedornot', 'GET');
      if (res && res?.status) {
        setIsSubscribed(res?.isSubscribed);
      }
    } catch (error) {
      toast.error(error?.message || 'something went wrong!!!');
    }
  };

  useEffect(() => {
    checkUserSubscription();
  }, []);
  
  return (
    <>
      <Cipbitheader navbg={(NavbarBgRoutes.includes(location.pathname) || NavbarBgRoutes?.find(item => item?.startsWith("/eventsCalender"))) && navbg} />
      {FreeLicenseRouter.includes(location.pathname) && <>
        <div className="try_fisibilty_wrapper" style={{
          background: !isSubscribed && '#FFDD00',
          color: '#0C2537'
        }}>

          {
            !isSubscribed && (
              <>
                <p style={{
                  color: '#0C2537'
                }}>Try Fisibility Now !</p>
                <button >FREE USER LICENSE</button>
              </>
            )
          }


        </div>
      </>}

 

      <Outlet />
      <Footer />
    </>
  )
}
